/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  image: ModelRegistry['guest-identity-image'];
}

export interface BookingIdentityImageSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingIdentityImageComponent extends Component<BookingIdentityImageSignature> {
  @service store!: Services['store'];
  @service notifications!: Services['notifications'];

  @service('repositories/guest-identity-image')
  guestIdentityImageRepository!: Services['repositories/guest-identity-image'];

  @tracked isDownloading = false;

  @cached
  get image(): ModelRegistry['guest-identity-image'] {
    return this.args.image;
  }

  @action
  @waitFor
  async handleDownloadImage(): Promise<void> {
    this.isDownloading = true;

    const { image } = this;

    try {
      await this.guestIdentityImageRepository.getRecords(
        image.guestIdentityVerificationId,
      );

      window.open(image.url, '_blank');
    } catch {
      this.notifications.error();
    } finally {
      this.isDownloading = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Identity::Image': typeof UiBookingIdentityImageComponent;
  }
}
